import React from 'react';
import Select from 'react-select';
import InvalidFeedback from './invalid-feedback.component';
import { useTranslation } from 'react-i18next';

interface TimeOption {
  value: string;
  label: string;
}

interface TimePickerProps {
  time: string;
  disable?: boolean;
  onChange: (value: string) => void;
  placeholder?: string;
  optional?: boolean;
  label?: string;
  requiredIndicator?: string;
  errors?: any;
}

const TimePicker = React.forwardRef<HTMLDivElement, TimePickerProps>(
  (
    {
      time,
      disable = false,
      onChange,
      placeholder = 'Selecciona una hora',
      optional = false,
      label,
      requiredIndicator = '',
      errors,
      ...props
    }: TimePickerProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const [times, setTimes] = React.useState<TimeOption[]>([]);
    const { t } = useTranslation();
    React.useEffect(() => {
      const times: TimeOption[] = [];
      for (let index = 7; index <= 22; index++) {
        const h = `${index}`.padStart(2, '0');
        times.push({ value: `${h}:00`, label: `${h}:00` });
        if (index !== 22) {
          times.push({ value: `${h}:30`, label: `${h}:30` });
        }
      }
      setTimes(times);
    }, []);

    const handleChange = (data: any) => {
      onChange(data ? data.value : '');
    };

    return (
      <div ref={ref}>
        <label className={'form-label ' + requiredIndicator}>
          {label}
          {optional && <span className="fs-8 text-muted ms-1">({t('general.optional')})</span>}
        </label>
        <Select
          {...props}
          options={times}
          isMulti={false}
          className={'form-select-custom ' + (errors ? ' is-invalid' : '')}
          classNamePrefix="form-select-custom"
          placeholder={placeholder}
          onChange={handleChange}
          value={times.find((option) => option.value === time) || null}
          isDisabled={disable}
        />
        <InvalidFeedback error={errors} />
      </div>
    );
  }
);

export default TimePicker;
